import { render, staticRenderFns } from "./superCReplaceCare.vue?vue&type=template&id=04950760&"
import script from "./superCReplaceCare.vue?vue&type=script&lang=js&"
export * from "./superCReplaceCare.vue?vue&type=script&lang=js&"
import style0 from "./superCReplaceCare.vue?vue&type=style&index=0&id=04950760&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports